import { RefObject, useEffect, useRef, useState } from "react";

interface RefreshableGrid {
  refreshData: () => void;
}

/**
 * Holds the free-text search state for an ODataGrid page and forces the grid
 * to reload when it changes
 *
 * Pair with GridSearchBox and createODataSearchFilters:
 *   const { searchText, setSearchText } = useGridSearch(gridRef);
 *   <GridSearchBox onSearch={setSearchText} />
 *   getData={(q) => getItems(createODataQueryFilter(q, createODataSearchFilters(searchText, ["firstName", "lastName"])))}
 */
export function useGridSearch(gridRef: RefObject<RefreshableGrid | null>) {
  const [searchText, setSearchText] = useState("");

  const isFirstRun = useRef(true);
  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
    gridRef.current?.refreshData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);

  return { searchText, setSearchText };
}

export default useGridSearch;
